const {
    MEMBERSHIP_OFFER_ENDPOINT,
    MEMBERSHIP_USER_TYPE_ENDPOINT,
    MEMBERSHIP_CUSTOMER_ENDPOINT,
    IS_USER_REGISTERED_ENDPOINT,
    MEMBERSHIP_ENABLE_AUTO_RENEWAL,
    MEMBERSHIP_DISABLE_AUTO_RENEWAL,
} = require('./constants');
const Fetcher = require('od-modules/utils/fetcher');

const buildUrl = (service = 'membership', endpointUrl) => {
    switch (service) {
        case ('membership'):
            return Odigeo.Settings.getProperty('membershipServiceFormatter')(endpointUrl);
        case ('user'):
            return Odigeo.Settings.getProperty('serviceUsersFormatter')(endpointUrl);
        default:
            return Odigeo.Settings.getProperty('membershipServiceFormatter')(endpointUrl);
    }
};

const activateMembershipAutoRenewal = () => {
    return Fetcher.put(buildUrl('membership', MEMBERSHIP_ENABLE_AUTO_RENEWAL)).json();
};

const disableMembershipAutoRenewal = () => {
    return Fetcher.put(buildUrl('membership', MEMBERSHIP_DISABLE_AUTO_RENEWAL)).json();
};

const getMembershipSubscriptionOffer = () => {
    return Fetcher.get(buildUrl('membership', MEMBERSHIP_OFFER_ENDPOINT)).json();
};

const getUserType = (email) => {
    return Fetcher.put(buildUrl('membership', MEMBERSHIP_USER_TYPE_ENDPOINT),
        email, false
    ).json();
};

const getMembershipCustomer = ({email, name, lastName}) => {
    return Fetcher.post(
        buildUrl('membership', MEMBERSHIP_CUSTOMER_ENDPOINT),
        {email, name, lastName}
    ).json();
};

const getAccountStatus = (email) => {
    return Fetcher.post(buildUrl('user', IS_USER_REGISTERED_ENDPOINT, ), email, false).json();
};

const updateMembershipProduct = (membershipInfo) => {
    const {email, name, lastName, quantity} = membershipInfo;
    const data = {
        email,
        quantity,
        name,
        lastNames: lastName,
        operation: null,
    };
    return Fetcher.post(buildUrl('membership', 'updatemembershipproduct'), data).json();
};

module.exports = {
    getMembershipSubscriptionOffer,
    getUserType,
    getMembershipCustomer,
    updateMembershipProduct,
    getAccountStatus,
    activateMembershipAutoRenewal,
    disableMembershipAutoRenewal,
};
